import React from "react";

import { Authentication } from "common/components/auth";

const StaffRequired = props => (
  <Authentication authenticationRequired requiredUserType="admin" {...props} />
);

export default StaffRequired;
